module.exports = __webpack_public_path__ + "static/media/foto1.774a65b2.png";